<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <Cogs /> -->
  </div>
</template>

<script>
// import Cogs from "vue-material-design-icons/Cogs.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCogs} from "@mdi/js"

export default {
  name: "CogsIcon",
  components: {
    SvgIcon
    // Cogs,
  },
  data() {
    return {
      path: mdiCogs,
    }
  }
}
</script>
